import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { applyStyleModifiers, type ModifiersConfig, type ModifierKeys } from 'styled-components-modifiers';

// Import components
import { Heading } from 'components/elements';

// Import styles
import { flex, customMinResponsive, size } from 'components/styles';

// Import types
import { Modifiers } from 'types/views/styles';

const ACTION_MODIFIERS: Modifiers = {
	payment: () => css`
		max-width: 49.5rem;
		gap: 2.4rem;
	`
};

const INFO_MODIFIERS: Modifiers = {
	payment: () => css`
		${customMinResponsive(
			size.xsmall,
			css`
				width: 49.5rem;
				align-self: center;
			`
		)}}

		${customMinResponsive(
			size.large,
			css`
				align-self: flex-start;
				max-width: 37.2rem;
			`
		)}}
	`
};

export const StepContentWrapper = styled.div`
	${flex({ fd: 'column' })}
	margin: 5rem auto;
	max-width: 76rem;
	gap: 5rem;

	${customMinResponsive(
		size.large,
		css`
			${flex({ jc: 'center', ai: 'flex-start' })}
			max-width: 117.4rem;
		`
	)}
`;

export const StepHeadingSecond = styled(Heading.Second)`
	font-size: 1.8rem;
	font-weight: ${({ theme }) => theme.font.distinct};
	margin: 0;
	align-self: flex-start;

	${customMinResponsive(
		size.xsmall,
		css`
			align-self: center;
		`
	)}

	${customMinResponsive(
		size.semi,
		css`
			align-self: flex-start;
		`
	)}
`;

export const StepActionContent = styled.div<{ modifiers?: ModifierKeys }>`
	${flex({ fd: 'column' })}
	gap: 3.2rem;
	max-width: 76rem;
	width: 100%;

	${applyStyleModifiers(ACTION_MODIFIERS as ModifiersConfig)};
`;

export const StepInfoContent = styled.div<{ fullSpace?: boolean; modifiers?: ModifierKeys }>`
	${flex({ fd: 'column' })}
	width: 100%;
	font-size: 1.8rem;

	${({ fullSpace }) =>
		!fullSpace &&
		customMinResponsive(
			size.xsmall,
			css`
				width: 60vw;
				min-width: 37.2rem;
			`
		)}

	${customMinResponsive(
		size.semi,
		css`
			width: 100%;
			align-self: flex-end;
		`
	)}

	${customMinResponsive(
		size.large,
		css`
			width: 37.2rem;
			align-self: flex-start;
		`
	)}

	${applyStyleModifiers(INFO_MODIFIERS as ModifiersConfig)};
`;

export const InfoContentWrapper = styled.div<{ hideBackground?: boolean }>`
	${flex({ fd: 'column', ai: 'space-between' })}
	width: 100%;
	border-radius: 2rem;
	border: 1px solid ${({ theme }) => rgba(theme.palette.white, 0.22)};
	background-color: ${({ theme, hideBackground }) => (hideBackground ? 'transparent' : rgba(theme.palette.white, 0.02))};
	margin-top: 2.4rem;
	padding: 1.5rem 2rem;
	position: relative;

	.react-loading-skeleton {
		line-height: normal;

		&:not(:first-child) {
			margin-top: 2rem;
		}
	}
`;

export const PremiumPacketDisabledInfo = styled.div`
	${flex({ ai: 'center' })}
	gap: 0.5rem;

	& > span {
		color: ${({ theme }) => rgba(theme.configurator.color.primary, 0.6)};
		text-align: center;
		font-size: 1.4rem;
		font-weight: ${({ theme }) => theme.font.light};
		line-height: 2rem;
		white-space: pre-line;
	}
`;

export const PacketsDescription = styled.p`
	font-size: 1.9rem;
	line-height: 1.4;
	color: ${({ theme }) => rgba(theme.configurator.color.primary, 0.6)};
	font-weight: ${({ theme }) => theme.font.light};
	align-self: center;
	text-align: center;
	margin: 0.5rem 2rem 1.5rem;

	${customMinResponsive(
		size.semi,
		css`
			font-size: 2.2rem;
		`
	)};
`;
